// A gallery doorway with a lit reveal. Shared by the SVG identity and signage.
export const galleryMarkPaths = [
  'M12 54V25C12 12 20 4 32 4s20 8 20 21v29h-6V25c0-10-5-16-14-16S18 15 18 25v29Z',
  'M25 54V28l14-7v33h-3V26l-8 4v24Z',
];
export function paintGalleryMark(context, x, y, width) {
  context.save();context.translate(x,y);context.scale(width/64,width/64);
  for(const path of galleryMarkPaths)context.fill(new Path2D(path));
  context.restore();
}
